import { CompanyTrialCancelledList } from "@/features/company/pages/CompanyTrialCancelledList";
import { FC } from "react";

const CompanyTrialCancelledListPage: FC = () => {
  return <CompanyTrialCancelledList />;
};

export default CompanyTrialCancelledListPage;
